<div class="action-menu" (clickOutside)="model.open = false">
  <div
    class="{{ classIcon }} action-btn-icon_{{id}}"
    (click)="open();"
    [ngClass]="{ open: model.open }"
  >
    <mat-icon
      aria-hidden="false"
      aria-label="..."
      svgIcon="icon_dots"
    ></mat-icon>
  </div>
  <div
    class="action-options"
    [id]="id"
    (clickOutside)="model.open = false"
    [ngClass]="{ open: model.open }"
  >
    <mat-nav-list class="action-menu-items" *ngIf="!model.isMobile" [id]="id">
      <ng-content *ngTemplateOutlet="content"></ng-content>
    </mat-nav-list>
  </div>
</div>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
